import { render, staticRenderFns } from "./EditMagazzinoView.vue?vue&type=template&id=778920f0&"
import script from "./EditMagazzinoView.vue?vue&type=script&lang=js&"
export * from "./EditMagazzinoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports